export const enum BannerImageType {
  /**
   * Оплата с расчётного счёта
   */
  PaymentFromCurrentAccount = 'payment-from-current-account',
  /**
   * Доступы команде
   */
  TeamAccess = 'team-access',
  /**
   * Веб-кабинет и Яндекс Go
   */
  WebCabinetAndYandexGo = 'web-cabinet-and-yandex-go',
  /**
   * Заказывайте доставки В приложении Яндекс Go
   */
  OrderDeliveriesInYandexGo = 'order-deliveries-in-yandex-go',
  /**
   * Диван
   */
  Sofa = 'sofa',
  /**
   * Грузовая машина
   */
  Truck = 'truck',
  /**
   * Отслеживайте заказы в приложении Яндекс Go
   */
  Courier = 'courier',
}

export const enum BannerAction {
  /**
   * Скопировать номер телефона
   */
  CopyPhoneNumber = 'copy-phone-number',
  /**
   * Скачать приложение
   */
  DownloadApp = 'download-app',
  /**
   * Подробнее
   */
  ReadMore = 'read-more',
}

export type Banner = {
  title: string
  imageType: BannerImageType
  action: BannerAction
  description?: string
  isBusiness?: boolean
  value?: string
}
